import React, { useContext } from 'react';
import { X } from 'lucide-react';
import { ToastContext } from '../contexts/ToastContext';

interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning';
}

export const ToastContainer: React.FC = () => {
  const { toasts } = useContext(ToastContext);

  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`flex items-center p-4 rounded-lg shadow-lg ${
            toast.type === 'success'
              ? 'bg-green-100 text-green-800'
              : toast.type === 'error'
              ? 'bg-red-100 text-red-800'
              : 'bg-yellow-100 text-yellow-800'
          }`}
        >
          <span className="flex-1">{toast.message}</span>
          <button className="ml-4 text-gray-500 hover:text-gray-700">
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};